/**
 * 
 * key
 * 
 */


const key = 'bXlDbGllbnRDaGFuZ2VzSW5Qcm9ncmVzcw=='

export default key 